import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { noticesApi, formatError } from '@/services/api';

export const fetchNotices = createAsyncThunk(
  'notice/fetchNotices',
  async (_, { rejectWithValue }) => {
    try {
      const notices = await noticesApi.getNotices();
      return notices.filter((notice) => notice.target === 'enterprise_portal');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response !== undefined) {
        return rejectWithValue({ error: formatError(error.response) });
      }
      throw error;
    }
  },
);
